export default function formEstoqueDTO({
  CODESTOQUE,
  ESTOQUE,
  IDPRODUTO,
  QUANTIDADE,
  DATA_MOVIMENTACAO,
  TIPOMOVIMENTACAO,
  ORIGEM,
  OBSERVACOES
}) {
  return {
    CODESTOQUE: CODESTOQUE || 1,
    ESTOQUE: ESTOQUE || "PADRÃO",
    IDPRODUTO,
    QUANTIDADE,
    DATA_MOVIMENTACAO,
    TIPOMOVIMENTACAO,
    ORIGEM,
    OBSERVACOES
  };
}